import axios from "axios";

export const state = {
    schoolsubjects: [],
};

export const getters = {
    schoolsubjects: state => state.schoolsubjects,
};

export const mutations = {
    setSubject(state, newValue) {
        state.schoolsubjects = newValue
    },
};

export const actions = {
    fetchSchoolSubjects({ commit }) {
        axios.get('/schoolsubjects').then(res => {
            commit('setSubject', res.data.schoolsubjects);
        })
    },
};
